import { render, staticRenderFns } from "./Pei.vue?vue&type=template&id=626b5d22&scoped=true"
import script from "./Pei.vue?vue&type=script&lang=js"
export * from "./Pei.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626b5d22",
  null
  
)

export default component.exports